module.exports = __webpack_public_path__ + "img/logo-light.271f1d2e.svg";